import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import axios from "axios";
import { clientAccess } from "../../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import TopHeader from "../../layout/TopHeader";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const YearArr = [];

for (var i = 2015; i <= 2030; i++) {
  YearArr.push(i)
}

class AssetManagement extends React.Component {
  state = {
    LandlordGroups: [],
    clientList: [],
    value: [],
    redirect: false,
    popupContent: "",
    messsagePopup: false,
    delete: false,
    disableOnEdit: false,
    delete: false,
    currentIndex: null,
    showFirstAddBtn: true,
    url: `${apiUrl.apiUrl.url}/close-deal/create/asset-management`,
    id: undefined,
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      asset_name: "",
      asset_type: "",
      value: "",
      fee_on_basis: "",
      fee: "",
      expiry_date: "",
      asset_status: "",
      term: "",

    },
  };

  resetForm(values) {
    this.state.initialValues = {};

    values.groupId = "";
    values.groupName = "";
    values.clientId = "";
    values.clientName = "";
    values.asset_name = "";
    values.asset_type = "";
    values.asset_status = "";
    values.fee = "";
    values.expiry_date = "";
    values.fee_on_basis = "";
    values.term = "";
    values.showFirstAddBtn = true;
    this.setState({});
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  complianceList = (clientId, id) => {
    var ths = this;
    fetch(
      `${apiUrl.apiUrl.url}/compliance/get-list-asset?client_id=${clientId}&id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "compliance data");
        // this.setState({
        //   assetCompliance: data.data,
        // });
        ths.state.initialValues.assetCompliance = data.data;
        ths.state.compliance_count = data.count;
        ths.state.compliance_percent = data.percent_count;
        ths.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCityId(e) {
    this.state.cityId = e.target.value;
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this deal",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/close-deal/create`,
          initialValues: {
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            asset_name: "",
            asset_type: "",
            // deal_type: "",
          },
        });
      } else {
        fetch(
          `${apiUrl.apiUrl.url}/close-deal/fetch-close-deal?id=${this.props.match.params.id}`,
          {headers}
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log(data.data, "data.data");
            this.setState({
              url: `${apiUrl.apiUrl.url}/close-deal/update?id=${this.props.match.params.id}`,
              initialValues: data.data,
              LandlordGroups: data.LandlordGroups,
              clientList: data.clientList,
            });
            this.state.initialValues.groupId = data.other_data.groupId;
            this.state.initialValues.groupName = data.other_data.groupName;
            this.state.initialValues.clientId = data.other_data.clientId;
            this.state.initialValues.clientName = data.other_data.clientName;
            this.setState({});
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({ delete: false });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        asset_type: "",
        // deal_type: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        asset_type: "",
        // deal_type: "",
      },
    });
  };


  year = () => {
    const arr = [];


    for (let i = 0; i < 10; i++) {
      arr.push(<option>{i}</option>);
    }
    return <div>year</div>
  }

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;

      this.complianceList(newValue.value, this.state.initialValues.assetId);
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to={"/close-deals/valuation/" + this.props.match.params.id} />;

    }
    return (
      <div className="parentContainer">
        <>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li><Link to="/close-deals">Close Deals</Link></li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Asset Management</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              // values.assetTypeId = this.state.initialValues.assetTypeId;
              // values.assetId = this.state.initialValues.assetId;
              // values.subAssetId = this.state.initialValues.subAssetId;
              console.log(values);
              var self = this;
              axios({
                method: "post",
                url: this.state.url,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({
                    messsagePopup: true,
                    popupContent: "Data Saved Successfully!",
                  });
                }
              });
            }}
          >
            {
              ({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          {/* Asset Type */}
                          <div className="newGridSectionInner">
                            <label>
                              Asset Type <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" readOnly="true" name="asset_type" />
                              <ErrorMessage
                                name="asset_type"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Asset Name */}
                          <div className="newGridSectionInner">
                            <label>
                              Asset Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" readOnly="true" name="asset_name" />
                              <ErrorMessage
                                name="asset_name"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Asset Management Status */}
                          <div className="newGridSectionInner">
                            <label>
                              Asset Management Status
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="asset_status" />
                              <ErrorMessage
                                name="asset_status"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Term */}
                          <div className="newGridSectionInner">
                            <label>
                              Term
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="term" />
                              <ErrorMessage
                                name="term"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Fee */}
                          <div className="newGridSectionInner">
                            <label>
                              Fee
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="fee" />
                              <ErrorMessage
                                name="fee"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Fee on basis */}
                          <div className="newGridSectionInner">
                            <label>
                              Fee on basis
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="fee_on_basis" />
                              <ErrorMessage
                                name="fee_on_basis"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          {/* Expiry Date */}
                          <div className="newGridSectionInner">
                            <label>
                              Expiry Date
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="expiry_date" />
                              <ErrorMessage
                                name="expiry_date"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>

                        {this.props.match.params.id !== undefined ? (
                          <div className="newGridSectionInner button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="update_button" disabled={isSubmitting}>
                              Update
                            </button>
                            <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                              <Link to="/close-deals/asset-management">
                                Reset
                              </Link>
                            </button>
                          </div>
                        ) : (
                          <div className="newGridSectionInner button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button" disabled={isSubmitting}>
                              <FontAwesomeIcon icon={faPlus} /> Add
                            </button>
                            <button type="reset" className="reset_button">
                              <Link
                                to="/close-deals/asset-management"
                                onClick={(e) => {
                                  this.resetForm(values);
                                }}
                              >
                                Reset
                              </Link>
                            </button>
                          </div>
                        )}

                      </div>
                    </Form>
                  </div>
                </>
              )}
          </Formik>
          <PopupMessage
            open={this.state.messsagePopup}
            content={this.state.popupContent}
            redirectAfterSave={this.redirectAfterSave}
          />
          <Popup open={this.state.delete} position="top center">
            {(close) => (
              <div>
                "Delete the item?"
                <a className="close" onClick={this.redirectToClose}>
                  &times;
                </a>
                <div>
                  <button type="button" onClick={this.redirectToDelete}>
                    Yes
                  </button>
                </div>
              </div>
            )}
          </Popup>
          {/* <AssetManagementTable/> */}
        </>
      </div>

    );
  }
}

export default withRouter(AssetManagement);